import styled from 'styled-components'

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  width: 100% ;
  padding: 40px 0;
  background-color: #f9f6ef;

`

export const CarouselContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 182px;

  @media (min-width: ${props => props.theme.mediaQuery.smallpc}) {
    height: 259px;
  }

`

export const TextAreaContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 32px;
`

export const TextContainer = styled.div<{ marginTop?: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 280px;
  padding: 0 28px;
  margin-top: ${props => props.marginTop ?? '0px'};

  @media(min-width: ${props => props.theme.mediaQuery.smallpc}){
    width: 400px;
    padding: 0 0;
  }
`
